import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "modal",
    "form",
    "dataProcessingConsent",
    "marketingConsent",
  ];

  connect() {}

  showModal(event) {
    event.preventDefault();
    this.modalTarget.classList.remove("hidden");
    document.body.style.overflow = "hidden";
  }

  closeModal() {
    this.modalTarget.classList.add("hidden");
    document.body.style.overflow = "";
  }

  confirmConsent() {
    const dataProcessingConsent = document.querySelector(
      'input[name="pension_application[data_processing_consent]"]:checked'
    );
    const marketingConsent = document.querySelector(
      'input[name="pension_application[marketing_consent]"]:checked'
    );

    if (!dataProcessingConsent || !marketingConsent) {
      alert("Please make a selection for both consent options.");
      return;
    }

    // Data processing consent must be true to proceed
    if (dataProcessingConsent.value === "false") {
      alert(
        "Data processing consent is required to submit your pension application."
      );
      return;
    }

    // Add consent values to form as hidden fields
    this.addConsentField(
      "pension_application[data_processing_consent]",
      dataProcessingConsent.value
    );
    this.addConsentField(
      "pension_application[marketing_consent]",
      marketingConsent.value
    );

    // Hide modal and submit form
    this.closeModal();
    this.formTarget.submit();
  }

  addConsentField(name, value) {
    // Remove existing field if it exists
    const existing = this.formTarget.querySelector(`input[name="${name}"]`);
    if (existing) {
      existing.remove();
    }

    // Add new hidden field
    const field = document.createElement("input");
    field.type = "hidden";
    field.name = name;
    field.value = value;
    this.formTarget.appendChild(field);
  }

  // Close modal when clicking outside
  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.closeModal();
    }
  }
}
